import GameScreen from '../components/GameScreen';

function WaitingScreen({ gameName, roomCode, onReconnect, onQuit, image, timerSeconds }) {
  return (
    <GameScreen
      gameName={gameName}
      roomCode={roomCode}
      onReconnect={onReconnect}
      onQuit={onQuit}
      timerSeconds={timerSeconds}
      backgroundImage={image}
    />
  );
}

export default WaitingScreen;
